<template>
  <!-- <v-app-bar height="130px" color="white"   app> -->
  <v-layout wrap justify-center>
    <v-flex
      xs12
      text-center
      py-2
      style="color: white; background-color: black; font-size: 12px"
    >
      <v-layout wrap justify-center>
        <!-- <v-flex xs1  text-right class="hidden-sm-and-down" style="background-color:red" >
                <v-img  width="9%" src="../../assets/images/hot-sale.svg"></v-img>
             </v-flex> -->
        <v-flex xs12 text-center>
          Use Coupon Code for 10% Discount
          <span
            style="
              border: 1px dotted white;
              padding-left: 3px;
              padding-right: 3px;
            "
            >SAVE 10</span
          >
          offer ends in 02.30.00
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="hidden-sm-and-down">
      <v-layout wrap py-5>
        <v-flex>
          <v-spacer></v-spacer>
        </v-flex>
        <v-flex md8 offset-1>
          <v-layout wrap style="font-family: robotoregular" justify-center>
            <v-flex align-self-center>
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'aboutus' }"
              >
                <span id="ac" style="padding: 5%"> About Us</span></router-link
              >
            </v-flex>
            <v-flex align-self-center>
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'beekeepers' }"
              >
                <span id="ac" style="padding: 5%"> Beekeepers</span>
              </router-link>
            </v-flex>
            <v-flex align-self-center>
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'map' }"
              >
                <span id="ac" style="padding: 5%"> Map </span>
              </router-link>
            </v-flex>
            <v-flex px-5 >
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'home' }"
              >
                <v-img width="70px"  contain src="../../assets/images/logo.svg">
                </v-img
              ></router-link>
            </v-flex>
            <v-flex align-self-center>
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'products' }"
              >
                <span id="ac" style="padding: 5%"> Shop </span></router-link
              >
            </v-flex>
            <v-flex align-self-center>
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'blog' }"
              >
                <span id="ac" style="padding: 5%"> Blog </span>
              </router-link>
            </v-flex>
            <v-flex align-self-center>
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'contactus' }"
              >
                <span id="ac" style="padding: 5%"> Contact </span>
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-flex>
          <v-spacer></v-spacer>
        </v-flex> -->
        <v-flex md2 text-left align-self-center>
          <v-layout wrap>
            <v-flex xs6 align-self-center text-right v-if="appLogin">
              <AccountMenu />
              <!-- <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'login' }"
              >
              <v-img width="25px" src="../../assets/images/account.svg"></v-img>
                </router-link> -->
            </v-flex>
            <v-flex xs7 text-center v-else>
              <router-link
                style="text-decoration: none; color: black"
                :to="{ name: 'login' }"
              >
                <v-btn outlined color="yellow"> Login</v-btn></router-link
              >
            </v-flex>
            <v-flex xs5 v-if="appLogin" align-self-center>
              <router-link style="text-decoration: none" :to="{ name: 'cart' }">
                <v-badge
                  color="#FEBD08"
                  :content="appCart ? appCart : '0'"
                  right
                  small
                  overlap
                  offset-x="5"
                >
                  <v-img
                    width="25px"
                    contain
                    src="../../assets/images/cart.svg"
                  >
                  </v-img>
                </v-badge>
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-if="$router.name != 'home'">
      <v-divider></v-divider>
    </v-flex>
    <v-flex xs12 py-3 class="hidden-md-and-up">
      <v-layout wrap px-3 justify-center>
        <v-flex xs4 md4 align-self-center>
          <v-img width="40px"  src="../../assets/images/logo.svg"> </v-img>
        </v-flex>
        <v-flex>
          <v-spacer></v-spacer>
        </v-flex>
        <v-flex xs5 text-right align-self-center>
          <span v-if="appLogin">
            <router-link
              style="text-decoration: none; color: black"
              :to="{ name: 'login' }"
            >
              <v-icon>mdi-account-circle-outline</v-icon></router-link
            >
          </span>
          <span v-else>
            <router-link
              style="text-decoration: none; color: black"
              :to="{ name: 'login' }"
            >
              <v-btn outlined> Login</v-btn></router-link
            >
          </span>
          <span v-if="appLogin" style="padding-left: 15%">
            <router-link style="text-decoration: none" :to="{ name: 'cart' }">
              <v-badge
                color="#FEBD08"
                :content="appCart ? appCart : '0'"
                right
                small
                overlap
                offset-x="5"
                ><v-icon>mdi-cart</v-icon></v-badge
              >
            </router-link>
          </span>
        </v-flex>
        <v-flex xs2 text-right>
          <v-app-bar-nav-icon @click="nav = true"></v-app-bar-nav-icon>
          <v-navigation-drawer absolute v-model="nav">
            <v-layout wrap justify-center>
              <v-flex xs12 text-left pl-3 pt-5>
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'aboutus' }"
                >
                  About Us</router-link
                >
              </v-flex>
              <v-flex xs11 py-1>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 text-left pl-3>
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'beekeepers' }"
                >
                  Beekeepers
                </router-link>
              </v-flex>
              <v-flex xs11 py-1>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 text-left pl-3>
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'map' }"
                >
                  Map
                </router-link></v-flex
              >
              <v-flex xs11 py-1>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 text-left pl-3>
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'products' }"
                >
                  Shop</router-link
                ></v-flex
              >
              <v-flex xs11 py-1>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 text-left pl-3>
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'blog' }"
                >
                  Blog
                </router-link>
              </v-flex>
              <v-flex xs11 py-1>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 text-left pl-3>
                <router-link
                  style="text-decoration: none; color: black"
                  :to="{ name: 'contactus' }"
                >
                  Contact
                </router-link>
              </v-flex>
              <v-flex xs11 py-1>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
          </v-navigation-drawer>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  <!-- </v-app-bar> -->
</template>
<script>
import AccountMenu from "./accountMenu";
export default {
  components: {
    AccountMenu,
  },
  data() {
    return {
      nav: false,
    };
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    // appType() {
    //   return this.$store.state.userType;
    // },
    appCart() {
      if (this.$store.state.cart_length == undefined) {
        return 0;
      } else {
        return this.$store.state.cart_length;
      }
    },
  },
};
</script>
<style>
#ac:hover {
  padding: 5%;
  background-color: #febd08;
  border-radius: 30px;
  color: white;
  transition: 0.2s;
}
</style>